import React, { useState } from 'react';
import axios from 'axios';
import API_URL from '../config/apiConfig'; // Assure-toi que ce chemin est bon

const ContactModal = ({ onClose }) => {
    const [formData, setFormData] = useState({
        email: '',
        subject: '',
        message: ''
    });
    const [status, setStatus] = useState('idle'); // idle, sending, success, error

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('sending');

        try {
            // C'est ici qu'on appelle ton backend au lieu d'ouvrir Outlook
            // Tu devras créer cette route '/contact' côté serveur si elle n'existe pas encore
            await axios.post(`${API_URL}/contact`, formData);
            
            setStatus('success');
            setTimeout(() => {
                onClose(); // On ferme le modal après 2 secondes
            }, 2000);
        } catch (error) {
            console.error("Erreur d'envoi", error);
            setStatus('error');
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden transform transition-all scale-100">
                
                {/* En-tête du Modal */}
                <div className="bg-[#1c2143] p-4 flex justify-between items-center">
                    <h3 className="text-white text-lg font-semibold flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-[#Ceaa5b]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                        Nous contacter
                    </h3>
                    <button onClick={onClose} className="text-gray-300 hover:text-white transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {/* Corps du formulaire */}
                <div className="p-6">
                    {status === 'success' ? (
                        <div className="text-center py-8">
                            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
                                <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            <h3 className="text-lg leading-6 font-medium text-gray-900">Message envoyé !</h3>
                            <p className="mt-2 text-sm text-gray-500">Nous vous répondrons dans les plus brefs délais.</p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Votre Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    required
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#Ceaa5b] focus:border-transparent outline-none transition-all"
                                    placeholder="exemple@email.com"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Sujet</label>
                                <select
                                    name="subject"
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#Ceaa5b] focus:border-transparent outline-none transition-all bg-white"
                                    value={formData.subject}
                                    onChange={handleChange}
                                >
                                    <option value="">Sélectionnez un sujet...</option>
                                    <option value="Connexion">Problème de connexion</option>
                                    <option value="Facturation">Question facturation</option>
                                    <option value="Technique">Support technique</option>
                                    <option value="Autre">Autre demande</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                                <textarea
                                    name="message"
                                    required
                                    rows="4"
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#Ceaa5b] focus:border-transparent outline-none transition-all resize-none"
                                    placeholder="Décrivez votre problème..."
                                    value={formData.message}
                                    onChange={handleChange}
                                ></textarea>
                            </div>

                            {status === 'error' && (
                                <p className="text-red-500 text-sm text-center">Une erreur est survenue. Veuillez réessayer.</p>
                            )}

                            <button
                                type="submit"
                                disabled={status === 'sending'}
                                className="w-full bg-[#1c2143] text-white font-bold py-3 px-4 rounded-lg hover:bg-[#2a3055] transition duration-300 flex justify-center items-center gap-2 shadow-lg disabled:opacity-70"
                            >
                                {status === 'sending' ? (
                                    <>
                                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                        Envoi en cours...
                                    </>
                                ) : (
                                    "Envoyer le message"
                                )}
                            </button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ContactModal;